import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

// Valores padrão (espelham o DEFAULT_SITE_CONTENT do backend)
const DEFAULTS = {
  // Hero
  hero_title_line1: "O patrimônio não se vende.",
  hero_title_line2: "Constrói-se.",
  hero_subtitle:
    "Transforme o consórcio imobiliário em um projeto patrimonial de longo prazo, com cenários, custos e riscos claros. Avalie o melhor caminho para o seu futuro através de uma análise individual e franca.",
  hero_cta_text: "Receber meu diagnóstico",
  hero_badge_text: "ANCORD · Banco Central",
  hero_portfolio_value: "R$ 13M",
  // About Me
  about_video_src: "/videos/MudeiDeCarreira50Anos.mp4",
  about_title: "Uma mudança de carreira",
  about_title_highlight: "aos 50",
  about_p1:
    "Passei 25 anos mergulhado em linhas de código, arquiteturas complexas e sistemas que não podiam falhar. No mundo da tecnologia, se a lógica é falha, o sistema cai. Mas, quando olhei para o mercado financeiro, vi algo assustador, as pessoas estavam tentando construir o futuro baseadas em achismos, promessas vazias e juros que corroem qualquer chance de liberdade.",
  about_p2:
    "Aos 50 anos, após perdas familiares que me fizeram recalcular a rota, entendi que a vida é curta demais para projetos inúteis. Decidi aplicar o rigor da tecnologia à coisa mais concreta que existe, o patrimônio. Saí do TI não para fugir, mas para levar a disciplina do 'sistema sem falhas' para o planejamento das famílias.",
  about_p3:
    "A matemática sempre vence o discurso. Hoje, com mais de R$ 13 milhões sob minha gestão e mais de 50 investidores que confiam no meu olhar analítico, eu não vendo apenas um produto.",
  about_p4:
    "Sei como é difícil construir um patrimônio suado e o medo que dá de tomar decisões erradas. Passei por isso na minha própria família. Por isso, se você busca um vendedor para te pressionar, não sou a pessoa certa. Mas se você quer um parceiro para olhar para os seus números com o mesmo cuidado que olho para os meus, seja bem-vindo ao método.",
  about_p5: "Não vendo consórcio. Desenho projetos de vida.",
  about_stat1_value: "25+",
  about_stat1_label: "anos em TI",
  about_stat2_value: "R$ 13M+",
  about_stat2_label: "sob gestão",
  about_stat3_value: "50+",
  about_stat3_label: "de investidores",
  // Stats
  stat1_value: "R$ 13M+",
  stat1_label: "Sob gestão",
  stat2_value: "50+",
  stat2_label: "Investidores atendidos",
  stat3_value: "25+",
  stat3_label: "Anos em tecnologia e análise",
  stat4_value: "906k+",
  stat4_label: "Pessoas que já utilizam este modelo",
  // Video Section
  video_src: "/videos/AlavancagemPatrimonial.mp4",
  video_title: "Alavancagem",
  video_title_highlight: "Imobiliária",
  video_subtitle: ": a matemática por trás da estratégia.",
  video_description:
    "O mercado fala muito sobre 'fazer o aluguel pagar a parcela'. É uma excelente estratégia? Sim. Mas não é mágica, é matemática. Aqui eu te mostro como investidores utilizam o capital de terceiros para a aquisição de ativos, mas sempre com o pé no chão. Colocamos na conta os riscos reais: o imóvel ficar vazio por uns meses, o condomínio, os impostos e a manutenção. Só avançamos se a conta fechar para a sua realidade.",
  // Testimonials
  testimonial1_name: "Renata M.",
  testimonial1_role: "Empresária · Porto Alegre",
  testimonial1_text:
    "Eu buscava um planejamento honesto, não um vendedor. O Juliano entrega exatamente isso — cada recomendação vem com a lógica e o número por trás.",
  testimonial2_name: "Alexandre P.",
  testimonial2_role: "Médico · 42 anos",
  testimonial2_text:
    "Em 18 meses, estruturei três cartas com renda contratada dos aluguéis. Tranquilidade que financiamento nenhum me deu antes.",
  testimonial3_name: "Carolina S.",
  testimonial3_role: "Advogada · 38 anos",
  testimonial3_text:
    "A consultoria foi tão sóbria que no começo duvidei. Dois anos depois, a conta fecha sozinha e meu patrimônio cresce sem eu sentir no bolso.",
  testimonial4_name: "Marcos R.",
  testimonial4_role: "CLT Sênior · Tech",
  testimonial4_text:
    "Planilha clara, tese clara, prazo claro. Nada de pressão. É o tipo de consultoria que eu queria ter encontrado há dez anos.",
  // FAQ
  faq1_q: "Consórcio é seguro?",
  faq1_a:
    "Sim. É regulamentado e fiscalizado pelo Banco Central do Brasil. Todas as administradoras precisam de autorização para operar, garantindo segurança jurídica e financeira.",
  faq2_q: "Qual a diferença entre consórcio e financiamento?",
  faq2_a:
    "No financiamento você paga juros compostos que podem dobrar o valor do imóvel. No consórcio não há juros — apenas uma taxa de administração menor. No consórcio formatado para investidores, as parcelas até a contemplação são reduzidas.",
  faq3_q: "Quanto preciso investir por mês?",
  faq3_a:
    "Trabalhamos com parcelas a partir de R$ 1.000/mês. O ideal depende do seu perfil e objetivos. Na consultoria gratuita definimos juntos o valor que faz sentido para sua estratégia.",
  faq4_q: "O que é alavancagem patrimonial?",
  faq4_a:
    "É a estratégia de usar capital de terceiros (outros consorciados) para adquirir um imóvel pagando apenas uma fração do valor total. Isso multiplica sua rentabilidade em relação à compra tradicional.",
  faq5_q: "Em quanto tempo sou contemplado?",
  faq5_a:
    "Não garantimos prazos — isso seria antiético. Utilizamos estratégias comprovadas de lance e formatação que historicamente reduzem o tempo de espera.",
  faq6_q: "Vocês ajudam a escolher o imóvel?",
  faq6_a:
    "Sim. Após a contemplação, a assessoria inclui a seleção do imóvel ideal para rentabilidade, considerando localização, potencial de valorização e retorno com aluguel.",
  faq7_q: "Esse serviço é para mim?",
  faq7_a:
    "Se você é profissional com visão de longo prazo e quer construir patrimônio de forma inteligente — sim. Recomendamos renda compatível com parcelas a partir de R$ 1.000/mês.",
  faq8_q: "Como a consultoria é remunerada se não há taxa inicial?",
  faq8_a:
    "Você não me paga para sentarmos e desenharmos o seu plano. Meu compromisso primeiro é entender a sua vida e fazer as contas junto com você. Como sou um consultor autorizado da Ademicon Novo Hamburgo, eu sou remunerado pela administradora apenas se chegarmos à conclusão de que o consórcio é realmente o melhor caminho para o seu patrimônio e você decidir seguir em frente. Se não for a melhor opção para você hoje, eu vou ser o primeiro a te dizer isso. Simples e transparente.",
  // CTA global
  cta_button_text: "Agendar consultoria",
  whatsapp_number: "5551999999999",
  whatsapp_message:
    "Olá Juliano! Vi seu site e quero saber mais sobre consultoria patrimonial.",
};

const SiteContentContext = createContext({ content: DEFAULTS, loading: true, refresh: () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${API}/site-content`);
      if (res.ok) {
        const data = await res.json();
        setContent({ ...DEFAULTS, ...data });
      }
    } catch {
      // mantém defaults em caso de erro de rede
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}

export { DEFAULTS };
